import { put, call, take, fork } from 'redux-saga/effects'
import { questionDeleteService } from '../../api/question'
import { questionDeleteSuccess } from '../../reducers/question/action'
import { QUESTION_DELETE } from '../../reducers/question/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* questionDeleteFlow(payload) {
  try {
    const { id, callback } = payload
    const response = yield call(questionDeleteService, id)

    yield put(questionDeleteSuccess(response.data))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* questionDeleteWatcher() {
  while (true) {
    const action = yield take(QUESTION_DELETE)
    const { payload } = action

    yield fork(generalSaga, questionDeleteFlow, payload)
  }
}
